// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register-form-block {
  position: relative;
}
.register-form-block .step-wizard {
  position: relative;
}
.register-form-block .step-wizard .step-indicator {
  position: relative;
  padding: 1.2rem;
  background: #FFFFFF;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.0509803922);
  border-radius: 8px;
  margin-top: -2rem;
}
.register-form-block .step-wizard .step-indicator .col-xl-3 {
  position: relative;
}
.register-form-block .step-wizard .step-indicator .col-xl-3.active .step {
  color: #00C596;
}
.register-form-block .step-wizard .step-indicator .col-xl-3.active .step i {
  color: #00C596;
}
.register-form-block .step-wizard .step-indicator .col-xl-3.active .caption {
  font-weight: 600;
  color: #212529;
}
.register-form-block .step-wizard .step-indicator .col-xl-3.complete .step {
  color: #00C596;
}
.register-form-block .step-wizard .step-indicator .col-xl-3.complete .step i {
  color: #00C596;
}
.register-form-block .step-wizard .step-indicator .col-xl-3.complete .caption {
  color: #212529;
}
.register-form-block .step-wizard .step-indicator .step i {
  color: #D5D5D5;
}
.register-form-block .step-wizard .step-indicator .step:hover {
  cursor: pointer;
}
.register-form-block .step-wizard .step-indicator .caption {
  font-size: 1rem;
  font-weight: 500;
  color: #212529;
  position: relative;
}
.register-form-block .step-wizard .step-indicator .caption::before {
  content: "";
  position: absolute;
  top: 12px;
  width: 100%;
  border: 1px dashed #213046;
  opacity: 0.5;
}
.register-form-block .step-wizard .step-indicator .caption span {
  background: #FFFFFF;
  padding-right: 6px;
  position: relative;
}
.register-form-block .step-wizard .stepOne .card,
.register-form-block .step-wizard .stepTwo .card,
.register-form-block .step-wizard .stepThree .card,
.register-form-block .step-wizard .stepFour .card {
  margin-bottom: 40px;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.0509803922);
  border-radius: 10px;
}
.register-form-block .step-wizard .stepOne .card:last-child,
.register-form-block .step-wizard .stepTwo .card:last-child,
.register-form-block .step-wizard .stepThree .card:last-child,
.register-form-block .step-wizard .stepFour .card:last-child {
  margin-bottom: 0;
}
.register-form-block .step-wizard .stepOne .stepFormOne form i,
.register-form-block .step-wizard .stepOne .stepFormTwo form i,
.register-form-block .step-wizard .stepOne .stepFormThree form i,
.register-form-block .step-wizard .stepTwo .stepFormOne form i,
.register-form-block .step-wizard .stepTwo .stepFormTwo form i,
.register-form-block .step-wizard .stepTwo .stepFormThree form i,
.register-form-block .step-wizard .stepThree .stepFormOne form i,
.register-form-block .step-wizard .stepThree .stepFormTwo form i,
.register-form-block .step-wizard .stepThree .stepFormThree form i,
.register-form-block .step-wizard .stepFour .stepFormOne form i,
.register-form-block .step-wizard .stepFour .stepFormTwo form i,
.register-form-block .step-wizard .stepFour .stepFormThree form i {
  color: #D5D5D5;
}
.register-form-block .step-wizard .stepOne .stepFormOne form i.active,
.register-form-block .step-wizard .stepOne .stepFormTwo form i.active,
.register-form-block .step-wizard .stepOne .stepFormThree form i.active,
.register-form-block .step-wizard .stepTwo .stepFormOne form i.active,
.register-form-block .step-wizard .stepTwo .stepFormTwo form i.active,
.register-form-block .step-wizard .stepTwo .stepFormThree form i.active,
.register-form-block .step-wizard .stepThree .stepFormOne form i.active,
.register-form-block .step-wizard .stepThree .stepFormTwo form i.active,
.register-form-block .step-wizard .stepThree .stepFormThree form i.active,
.register-form-block .step-wizard .stepFour .stepFormOne form i.active,
.register-form-block .step-wizard .stepFour .stepFormTwo form i.active,
.register-form-block .step-wizard .stepFour .stepFormThree form i.active {
  color: #077EE6;
}
.register-form-block .step-wizard .stepOne .stepFormOne form i.error,
.register-form-block .step-wizard .stepOne .stepFormTwo form i.error,
.register-form-block .step-wizard .stepOne .stepFormThree form i.error,
.register-form-block .step-wizard .stepTwo .stepFormOne form i.error,
.register-form-block .step-wizard .stepTwo .stepFormTwo form i.error,
.register-form-block .step-wizard .stepTwo .stepFormThree form i.error,
.register-form-block .step-wizard .stepThree .stepFormOne form i.error,
.register-form-block .step-wizard .stepThree .stepFormTwo form i.error,
.register-form-block .step-wizard .stepThree .stepFormThree form i.error,
.register-form-block .step-wizard .stepFour .stepFormOne form i.error,
.register-form-block .step-wizard .stepFour .stepFormTwo form i.error,
.register-form-block .step-wizard .stepFour .stepFormThree form i.error {
  color: #e60719;
}
.register-form-block .step-wizard .stepOne .aside-status .nav-item,
.register-form-block .step-wizard .stepTwo .aside-status .nav-item,
.register-form-block .step-wizard .stepThree .aside-status .nav-item,
.register-form-block .step-wizard .stepFour .aside-status .nav-item {
  margin-bottom: 10px;
}
.register-form-block .step-wizard .stepOne .aside-status .nav-item:last-child,
.register-form-block .step-wizard .stepTwo .aside-status .nav-item:last-child,
.register-form-block .step-wizard .stepThree .aside-status .nav-item:last-child,
.register-form-block .step-wizard .stepFour .aside-status .nav-item:last-child {
  margin-bottom: 0;
}
.register-form-block .step-wizard .stepOne .aside-status .nav-item .nav-link,
.register-form-block .step-wizard .stepTwo .aside-status .nav-item .nav-link,
.register-form-block .step-wizard .stepThree .aside-status .nav-item .nav-link,
.register-form-block .step-wizard .stepFour .aside-status .nav-item .nav-link {
  font-size: 15px;
  color: #213046;
}
.register-form-block .step-wizard .stepOne .aside-status .nav-item .nav-link i,
.register-form-block .step-wizard .stepTwo .aside-status .nav-item .nav-link i,
.register-form-block .step-wizard .stepThree .aside-status .nav-item .nav-link i,
.register-form-block .step-wizard .stepFour .aside-status .nav-item .nav-link i {
  font-size: 18px;
  color: #D5D5D5;
}
.register-form-block .step-wizard .stepOne .aside-status .nav-item .nav-link.active i,
.register-form-block .step-wizard .stepTwo .aside-status .nav-item .nav-link.active i,
.register-form-block .step-wizard .stepThree .aside-status .nav-item .nav-link.active i,
.register-form-block .step-wizard .stepFour .aside-status .nav-item .nav-link.active i {
  color: #077EE6;
}
.register-form-block .step-wizard .stepTwo .stepFormOne .single-card {
  margin-bottom: 20px;
}
.register-form-block .step-wizard .stepTwo .stepFormOne .single-card .card .fa-check-circle {
  font-size: 24px;
  color: #077EE6;
  position: absolute;
  right: -4px;
  top: -7px;
  visibility: hidden;
}
.register-form-block .step-wizard .stepTwo .stepFormOne .single-card .card:hover, .register-form-block .step-wizard .stepTwo .stepFormOne .single-card .card:active, .register-form-block .step-wizard .stepTwo .stepFormOne .single-card .card.active {
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1607843137) !important;
  border: 2px solid #077EE6;
}
.register-form-block .step-wizard .stepTwo .stepFormOne .single-card .card:hover .fa-check-circle, .register-form-block .step-wizard .stepTwo .stepFormOne .single-card .card:active .fa-check-circle, .register-form-block .step-wizard .stepTwo .stepFormOne .single-card .card.active .fa-check-circle {
  visibility: visible;
}
.register-form-block .step-wizard .stepThree .stepFormOne .order-summert-table {
  position: relative;
}
.register-form-block .step-wizard .stepThree .stepFormOne .order-summert-table li {
  padding: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
.register-form-block .step-wizard .stepThree .stepFormOne .order-summert-table li:first-child {
  margin-bottom: 15px;
  border-radius: 6px;
}
.register-form-block .step-wizard .stepThree .stepFormOne .order-summert-table li:first-child, .register-form-block .step-wizard .stepThree .stepFormOne .order-summert-table li:last-child {
  border-bottom: none;
}
.register-form-block .step-wizard .stepThree .stepFormOne .order-summert-table li:nth-child(4), .register-form-block .step-wizard .stepThree .stepFormOne .order-summert-table li:nth-child(6) {
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/student_module/components/register_steps/_registerStepwizard.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AACI;EACI,kBAAA;AACR;AACQ;EACI,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,oDAAA;EACA,kBAAA;EACA,iBAAA;AACZ;AACY;EACI,kBAAA;AAChB;AAEoB;EACI,cAAA;AAAxB;AAEwB;EACI,cAAA;AAA5B;AAIoB;EACI,gBAAA;EACA,cAAA;AAFxB;AAQoB;EACI,cAAA;AANxB;AAQwB;EACI,cAAA;AAN5B;AAUoB;EACI,cAAA;AARxB;AAcgB;EACI,cAAA;AAZpB;AAegB;EACI,eAAA;AAbpB;AAiBY;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAfhB;AAiBgB;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,0BAAA;EACA,YAAA;AAfpB;AAkBgB;EACI,mBAAA;EACA,kBAAA;EACA,kBAAA;AAhBpB;AAyBY;;;;EACI,mBAAA;EACA,oDAAA;EACA,mBAAA;AApBhB;AAsBgB;;;;EACI,gBAAA;AAjBpB;AAwBgB;;;;;;;;;;;;EACI,cAAA;AAXpB;AAaoB;;;;;;;;;;;;EACI,cAAA;AAAxB;AAGoB;;;;;;;;;;;;EACI,cAAA;AAUxB;AAJgB;;;;EACI,mBAAA;AASpB;AAPoB;;;;EACI,gBAAA;AAYxB;AAToB;;;;EACI,eAAA;EACA,cAAA;AAcxB;AAZwB;;;;EACI,eAAA;EACA,cAAA;AAiB5B;AAdwB;;;;EACI,cAAA;AAmB5B;AAXY;EACI,mBAAA;AAahB;AAVoB;EACI,eAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;AAYxB;AAToB;EAGI,+DAAA;EACA,yBAAA;AASxB;AAPwB;EACI,mBAAA;AAS5B;AADY;EACI,kBAAA;AAGhB;AADgB;EACI,aAAA;EACA,6CAAA;AAGpB;AADoB;EACI,mBAAA;EACA,kBAAA;AAGxB;AAAoB;EAEI,mBAAA;AACxB;AAEoB;EAEI,gBAAA;AADxB","sourcesContent":[".register-form-block {\n    position: relative;\n\n    .step-wizard {\n        position: relative;\n\n        .step-indicator {\n            position: relative;\n            padding: 1.2rem;\n            background: #FFFFFF;\n            box-shadow: 0px 3px 20px #0000000D;\n            border-radius: 8px;\n            margin-top: -2rem;\n\n            .col-xl-3 {\n                position: relative;\n\n                &.active {\n                    .step {\n                        color: #00C596;\n\n                        i {\n                            color: #00C596;\n                        }\n                    }\n\n                    .caption {\n                        font-weight: 600;\n                        color: #212529;\n\n                    }\n                }\n\n                &.complete {\n                    .step {\n                        color: #00C596;\n\n                        i {\n                            color: #00C596;\n                        }\n                    }\n\n                    .caption {\n                        color: #212529;\n                    }\n                }\n            }\n\n            .step {\n                i {\n                    color: #D5D5D5;\n                }\n\n                &:hover {\n                    cursor: pointer;\n                }\n            }\n\n            .caption {\n                font-size: 1rem;\n                font-weight: 500;\n                color: #212529;\n                position: relative;\n\n                &::before {\n                    content: '';\n                    position: absolute;\n                    top: 12px;\n                    width: 100%;\n                    border: 1px dashed #213046;\n                    opacity: 0.5;\n                }\n\n                span {\n                    background: #FFFFFF;\n                    padding-right: 6px;\n                    position: relative;\n                }\n            }\n        }\n\n        .stepOne,\n        .stepTwo,\n        .stepThree,\n        .stepFour {\n            .card {\n                margin-bottom: 40px;\n                box-shadow: 0px 3px 20px #0000000D;\n                border-radius: 10px;\n\n                &:last-child {\n                    margin-bottom: 0;\n                }\n            }\n\n            .stepFormOne,\n            .stepFormTwo,\n            .stepFormThree {\n                form i {\n                    color: #D5D5D5;\n\n                    &.active {\n                        color: #077EE6;\n                    }\n\n                    &.error {\n                        color: #e60719;\n                    }\n                }\n            }\n\n            .aside-status {\n                .nav-item {\n                    margin-bottom: 10px;\n\n                    &:last-child {\n                        margin-bottom: 0;\n                    }\n\n                    .nav-link {\n                        font-size: 15px;\n                        color: #213046;\n\n                        i {\n                            font-size: 18px;\n                            color: #D5D5D5;\n                        }\n\n                        &.active i {\n                            color: #077EE6;\n                        }\n                    }\n                }\n            }\n        }\n\n        .stepTwo {\n            .stepFormOne .single-card {\n                margin-bottom: 20px;\n\n                .card {\n                    .fa-check-circle {\n                        font-size: 24px;\n                        color: #077EE6;\n                        position: absolute;\n                        right: -4px;\n                        top: -7px;\n                        visibility: hidden;\n                    }\n\n                    &:hover,\n                    &:active,\n                    &.active {\n                        box-shadow: 0px 0px 30px #00000029 !important;\n                        border: 2px solid #077EE6;\n\n                        .fa-check-circle {\n                            visibility: visible;\n                        }\n                    }\n                }\n            }\n        }\n\n        .stepThree {\n            .stepFormOne .order-summert-table {\n                position: relative;\n\n                li {\n                    padding: 12px;\n                    border-bottom: 1px solid rgba(0, 0, 0, 0.125);\n\n                    &:first-child {\n                        margin-bottom: 15px;\n                        border-radius: 6px;\n                    }\n\n                    &:first-child,\n                    &:last-child {\n                        border-bottom: none;\n                    }\n\n                    &:nth-child(4),\n                    &:nth-child(6) {\n                        font-weight: 600;\n                    }\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
